
import { supabase } from '../../supabase';
import { BrowserStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get browser distribution statistics
 */
export const getBrowserStats = async (
  startDate: Date, 
  endDate: Date, 
  authFilter: AuthFilter = 'all'
): Promise<BrowserStat[]> => {
  const { data, error } = await supabase.rpc('get_browser_stats_aggregated', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error('Error fetching browser stats:', error);
    throw error;
  }
  
  return (data || []).map(item => ({
    browser: item.browser,
    count: Number(item.count)
  }));
};
